import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class ShootButton {
  /** @type Phaser.GameObjects.Sprite */
  ShootButton

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {
    let buttonOffset = GameUtil.getViewPercentage(
      { X: 10, Y: 10 },
      this.sceneContext.plataforma
    )

    this.ShootButton = this.sceneContext.add
      .image(0, 0, 'shooterButton')
      .setOrigin(0.5)
      .setDepth(1)
      .setInteractive({ cursor: 'pointer' })

    Phaser.Display.Align.In.BottomLeft(
      this.ShootButton,
      this.sceneContext.plataforma,
      -buttonOffset.X,
      -buttonOffset.Y
    )

    this.ShootButton.on('pointerdown', () => {
      this.sceneContext.fireAShot()
    })
  }
}
